export default function dateFormats(date) {
  if (date) {
    var day = ('0' + new Date(date).getDate()).slice(-2);
    var month = new Date(date).getMonth() + 1;
    var monthNo = ('0' + month).slice(-2);
    var year = new Date(date).getFullYear();
    var noTimeFormat = year + '-' + monthNo + '-' + day;

    return noTimeFormat;
  }
}
